import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetCelebrations = () => {
  const get = useTypedApiClient({
    path: '/celebrations',
    method: 'get',
  })
  return useQuery({
    queryKey: ['/celebrations'],
    queryFn: async () => {
      const { data } = await get({})
      return data
    },
  })
}
